var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class DirtinessTracker {
  constructor() {
    __publicField(this, "changesCount", 0);
    __publicField(this, "touchedCount", 0);
  }
  getTotalTouchCount() {
    return this.touchedCount;
  }
  hasChanges() {
    return this.changesCount > 0;
  }
  reset() {
    this.changesCount = 0;
  }
  increaseBy(delta) {
    this.changesCount += delta;
    this.touchedCount++;
  }
}
export {
  DirtinessTracker
};
//# sourceMappingURL=DirtinessTracker.js.map
